<div class="iframe-container">
    <div class="center-text">{{agentName}}</div>
    <div class="cxone-agent-container" id="launchCXA">Carregando Iframe...></div>
</div>




